import React from 'react';
import '../../styles/Footer.css';
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn, FaYoutube, FaSlack } from 'react-icons/fa';
import 'boxicons/css/boxicons.min.css';
import { Link, useNavigate } from 'react-router-dom';

const Footer = () => {
    const navigate = useNavigate();

    const handleStartApplication = () => {
        navigate('/share-link');
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    return (
        <>
            <div className='FAQ-last-div'>
                <span className='FAQ-h2-lastHeading'>Early applications encouraged. Limited seats are available.</span>

                <div className='FAQ-button-div'>
                    <Link to='/fees' onClick={() => window.scrollTo(0, 0)}><button className='FAQ-button-loan'>View Payment Plan</button></Link>
                    <Link to='/fees' onClick={() => window.scrollTo(0, 0)}> <button className='FAQ-button-loan'>Loan offered at EMI</button></Link>
                    <Link to='/fees' onClick={() => window.scrollTo(0, 0)}>  <button className='FAQ-button-loan'>Special Corporate Enrollment Pricing</button></Link>
                </div>
                <div className="neon-btn-wrapper">
                    <div onClick={handleStartApplication} className="neon-btn">
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        Start Application Now
                    </div>
                </div>
            </div>
            <footer>
                <div className="content">
                    <div className="top">
                        <div className="logo-details">
                            <span className="logo_name">FINXL Business School</span>
                        </div>

                        <div className="social-icons">

                            <a href="https://www.instagram.com/finxl_business_school/" target="_blank" rel="noopener noreferrer">
                                <i className='bx bxl-instagram' style={{ color: 'white' }}></i>
                            </a>
                            <a href="https://www.linkedin.com/company/fbs-finxl-business-school/" target="_blank" rel="noopener noreferrer">
                                <i className='bx bxl-linkedin' style={{ color: 'white' }}></i>
                            </a>
                            <a href="https://www.facebook.com/profile.php?id=61561972892184" target="_blank" rel="noopener noreferrer">
                                <i className='bx bxl-facebook' style={{ color: 'white' }}></i>
                            </a>
                            <a href="https://api.whatsapp.com/send?phone=918109240909" target="_blank" rel="noopener noreferrer">
                                <i className='bx bxl-whatsapp' style={{ color: 'white' }}></i>
                            </a>
                            <i className="bx bx-bullhorn"></i>
                        </div>
                    </div>
                    <div className="link-boxes">
                        
                        <ul className="box" id="wh">
                            <li className="link_name">Whatsapp Us @</li>
                            <li>
                                <a href="https://wa.me/9661626371" target="blank">+91 96 61 62 63 71</a>
                            </li>
                            <li>
                                <a href="https://wa.me/8109240909">+91 81 09 24 09 09</a>
                            </li>
                            <li>
                                <a href="https://wa.me/9158882688">+91 91 58 88 26 88</a>
                            </li>
                            <li>
                                <a href="https://wa.me/9661626380">+91 96 61 62 63 80</a>
                            </li>
                        </ul>
                        <ul className="box">
                            <li className="link_name">Email Us @</li>
                            <li>
                                <a href="mailto:admission@fbsedu.in">admission@fbsedu.in</a>
                            </li>
                            <li>
                                <a href="mailto:admission@finxl.in">admission1@finxl.in</a>
                            </li>
                            <li>
                                <a href="mailto:admission2@finxl.in">admission2@finxl.in</a>
                            </li>
                        </ul>
                        <ul className="box" id="wh">
                            <li className="link_name">Timings</li>
                            <li><a href="#">Mon To Sun</a></li>
                            <li><a href="#">10:00 AM – 7:00 PM</a></li>
                            <li><a href="#">Visiting Hours / Enquiry</a></li>
                        </ul>
                        <ul className="box">
                            <li className="link_name">Address</li>
                            <li>
                                <a
                                    href="https://maps.app.goo.gl/hxdCRp1pLbNUsDcw7"
                                    target="blank"
                                >
                                    Address : 301, Magnolia Business Center, Behind Star Market,
                                    Baner Pashan Link Road, Baner, Pune, Maharashtra, India 411021
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div className="link">
                <ul className="box">
                            {/* <li className="link_name">MBA In</li> */}
                            <div className="city-wise-link-footer">
                            <li>
                                    <Link
                                        to="/mba-in-finance/pune"
                                        title="MBA Finance in Pune"
                                        target="_blank">
                                        Pune
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/mba-in-finance/mumbai"
                                        title="MBA in Finance Program in Mumbai"
                                        target="_blank">
                                        Mumbai
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/mba-in-finance/bangalore"
                                        title="MBA in Finance Program in Bangalore"
                                        target="_blank">
                                        Bangalore
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/mba-in-finance/haryana"
                                        title="MBA in Finance Program in Haryana"
                                        target="_blank">
                                        Haryana
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/mba-in-finance/hyderabad"
                                        title="MBA in Finance Program in Hyderabad"
                                        target="_blank">
                                        Hyderabad
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/mba-in-finance/vadodara"
                                        title="MBA in Finance Program in Vadodara"
                                        target="_blank">
                                        Vadodara
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/mba-in-finance/ahmedabad"
                                        title="MBA in Finance Program in Ahmedabad"
                                        target="_blank">
                                        Ahmedabad 
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/mba-in-finance/gurgaon"
                                        title="MBA in Finance Program in Gurgaon"
                                        target="_blank">
                                        Gurgaon
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/mba-in-finance/chennai"
                                        title="MBA in Finance Program in Chennai"
                                        target="_blank">
                                        Chennai
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/mba-in-finance/kolkata"
                                        title="MBA in Finance Program in Kolkata"
                                        target="_blank">
                                        Kolkata
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/mba-in-finance/lucknow"
                                        title="MBA in Finance Program in Lucknow"
                                        target="_blank">
                                        Lucknow
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/mba-in-finance/dhanbad"
                                        title="MBA in Finance Program in Dhanbad"
                                        target="_blank">
                                        Dhanbad
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/mba-in-finance/dehradun"
                                        title="MBA in Finance Program in Dehradun"
                                        target="_blank">
                                        Dehradun
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/mba-in-finance/thane"
                                        title="MBA in Finance Program in Thane"
                                        target="_blank">
                                        Thane
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/mba-in-finance/jalgaon"
                                        title="MBA in Finance Program in Jalgaon"
                                        target="_blank">
                                        Jalgaon
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/mba-in-finance/dhule"
                                        title="MBA in Finance Program in Dhule"
                                        target="_blank">
                                        Dhule
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/mba-in-finance/kannur"
                                        title="MBA in Finance Program in Kannur"
                                        target="_blank">
                                        Kannur
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/mba-in-finance/kolhapur"
                                        title="MBA in Finance Program in Kolhapur"
                                        target="_blank">
                                        Kolhapur
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/mba-in-finance/ludhiana"
                                        title="MBA in Finance Program in Ludhiana"
                                        target="_blank">
                                        Ludhiana
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/mba-in-finance/jamshedpur"
                                        title="MBA in Finance Program in Jamshedpur"
                                        target="_blank">
                                        Jamshedpur
                                    </Link>
                                </li>                              
                                <li>
                                    <Link
                                        to="/mba-in-finance/gujarat"
                                        title="MBA in Finance Program in Gujarat"
                                        target="_blank">
                                        Gujarat
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/mba-in-finance/bhopal"
                                        title="MBA in Finance Program in Bhopal"
                                        target="_blank">
                                        Bhopal
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/mba-in-finance/nashik"
                                        title="MBA in Finance Program in Nashik"
                                        target="_blank">
                                        Nashik
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/mba-in-finance/jabalpur"
                                        title="MBA in Finance Program in Jabalpur"
                                        target="_blank">
                                        Jabalpur
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/mba-in-finance/chandigarh"
                                        title="MBA in Finance Program in Chandigarh"
                                        target="_blank">
                                        Chandigarh
                                    </Link>
                                </li> 
                                <li>
                                    <Link
                                        to="/mba-in-finance/amravati"
                                        title="MBA in Finance Program in Amravati"
                                        target="_blank">
                                        Amravati
                                    </Link>
                                </li>                               
                                
                                <li>
                                    <Link
                                        to="/mba-in-finance/noida"
                                        title="MBA in Finance Program in Noida"
                                        target="_blank">
                                        Noida
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/mba-in-finance/indore"
                                        title="MBA in Finance Program in Indore"
                                        target="_blank">
                                        Indore
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/mba-in-finance/jaipur"
                                        title="MBA in Finance Program in Jaipur"
                                        target="_blank">
                                        Jaipur
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/mba-in-finance/kanpur"
                                        title="MBA in Finance Program in Kanpur"
                                        target="_blank">
                                        Kanpur
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/mba-in-finance/nagpur"
                                        title="MBA in Finance Program in Nagpur"
                                        target="_blank">
                                        Nagpur
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/mba-in-finance/patna"
                                        title="MBA in Finance Program in Patna"
                                        target="_blank">
                                        Patna
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/mba-in-finance/satara"
                                        title="MBA in Finance Program in Satara"
                                        target="_blank">
                                        Satara
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/mba-in-finance/sangli"
                                        title="MBA in Finance Program in Sangli"
                                        target="_blank">
                                        Sangli
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/mba-in-finance/agra"
                                        title="MBA in Finance Program in Agra"
                                        target="_blank">
                                        Agra
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/mba-in-finance/varanasi"
                                        title="MBA in Finance Program in Varanasi"
                                        target="_blank">
                                        Varanasi
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/mba-in-finance/prayagraj"
                                        title="MBA in Finance Program in Prayagraj"
                                        target="_blank">
                                        Prayagraj
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/mba-in-finance/amritsar"
                                        title="MBA in Finance Program in Amritsar"
                                        target="_blank">
                                        Amritsar
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/mba-in-finance/surat"
                                        title="MBA in Finance Program in Surat"
                                        target="_blank">
                                        Surat
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/mba-in-finance/delhi"
                                        title="MBA in Finance Program in Delhi"
                                        target="_blank">
                                        Delhi
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/mba-in-finance/solapur"
                                        title="MBA in Finance Program in Solapur"
                                        target="_blank">
                                        Solapur
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/mba-in-finance/bhilai"
                                        title="MBA in Finance Program in Bhilai"
                                        target="_blank">
                                        Bhilai
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/mba-in-finance/ranchi"
                                        title="MBA in Finance Program in Ranchi"
                                        target="_blank">
                                        Ranchi
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/mba-in-finance/guwahati"
                                        title="MBA in Finance Program in Guwahati"
                                        target="_blank">
                                        Guwahati
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/mba-in-finance/gwalior"
                                        title="MBA in Finance Program in Gwalior"
                                        target="_blank">
                                        Gwalior
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/mba-in-finance/hubballi-dharwad"
                                        title="MBA in Finance Program in Hubballi-Dharwad"
                                        target="_blank">
                                        Hubballi-Dharwad
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/mba-in-finance/visakhapatnam"
                                        title="MBA in Finance Program in Visakhapatnam"
                                        target="_blank">
                                        Visakhapatnam
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/mba-in-finance/bhubaneswar"
                                        title="MBA in Finance Program in Bhubaneswar"
                                        target="_blank">
                                        Bhubaneswar
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/mba-in-finance/navi-mumbai"
                                        title="MBA in Finance Program in Navi-Mumbai"
                                        target="_blank">
                                        Navi-Mumbai
                                    </Link>
                                </li>

                                <li>
                                    <Link
                                        to="/mba-in-finance/aurangabad"
                                        title="MBA in Finance Program in Aurangabad"
                                        target="_blank">
                                        Aurangabad
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/mba-in-finance/vasai-virar"
                                        title="MBA in Finance Program in Vasai-Virar"
                                        target="_blank">
                                        Vasai-Virar
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/mba-in-finance/pimpri-chinchwad"
                                        title="MBA in Finance Program in Pimpri-Chinchwad"
                                        target="_blank">
                                        Pimpri-Chinchwad
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/mba-in-finance/maharashtra"
                                        title="MBA in Finance Program in Maharashtra"
                                        target="_blank">
                                        Maharashtra
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/mba-in-finance/india"
                                        title="MBA in Finance Program in India"
                                        target="_blank">
                                        India
                                    </Link>
                                </li>
                            </div>
                        </ul>
                </div>
                
                </div>
                
                <div className="bottom-details">
                    <div className="bottom_text">
                        <span className="copyright_text">Copyright © 2024 <a href="#">FINXL.</a>All rights reserved</span>
                        <span className="policy_terms">
                            <Link to='/placment-policy' onClick={() => window.scrollTo(0, 0)}>Privacy policy</Link>
                            <Link to='/terms' onClick={() => window.scrollTo(0, 0)}>Refund Terms & Conditions</Link>
                            <Link to="/login" onClick={() => window.scrollTo(0, 0)} className="hidden-link">Admin Login</Link>
                        </span>
                    </div>
                </div>
                
            </footer>
        </>
    );
}

export default Footer;
